import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Injector,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Register } from '@app/utils/type-registry';
import { Observable, of } from 'rxjs';
import { BaseWidgetComponent } from './base-widget.component';
import {
  DialogInput,
  DialogOutput,
  LocalActionModel,
} from '@trackback/widgets';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';

@Register('Dialog')
@Component({
  selector: 'tb-dialog',
  template: `
    <ng-container [dynamicWidget]="input.contentWidget" [context]="context" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [DynamicWidgetDirective],
})
export class DialogComponent extends BaseWidgetComponent<
  DialogInput,
  DialogOutput
> {
  @HostBinding('style.paddingTop')
  paddingTop?: string;

  @HostBinding('style.paddingRight')
  paddingRight?: string;

  @HostBinding('style.paddingBottom')
  paddingBottom?: string;

  @HostBinding('style.paddingLeft')
  paddingLeft?: string;

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) scope: DialogData,
    public _dialogRef: MatDialogRef<DialogComponent>
  ) {
    super(injector);
    this.input = scope.input;
    this.context = scope.context;
  }

  handleCloseAction(action: LocalActionModel): Observable<any> {
    this._dialogRef.close(action.payload);
    return of(action.payload);
  }
}

type DialogData = {
  input: DialogInput;
  context: Record<string, any>;
};
